// src/config.js
const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    environment: process.env.REACT_APP_ENV,
    socketUrl: process.env.REACT_APP_EXPERIAN_SOCKET_DEV,
    experianUrl: process.env.REACT_APP_EXPERIAN_API,
//   experianEndPoint:process.env.REACT_APP_EXPERIAN_API,
  };
  export default config;
  
 